module.exports = "<div class=\"form-group\">\n    <label class=\"control-label\">Time Interval</label>\n    <select class=\"form-control\" ng-model=\"visualization.options.timeInterval\">\n      <option value=\"daily\">Daily</option>\n      <option value=\"weekly\">Weekly</option>\n      <option value=\"monthly\">Monthly</option>\n    </select>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/visualizations/cohort/cohort-editor.html
// module id = 708
// module chunks = 1